import misc from './misc';

const { getEmailQuery, buildTestEmail } = misc;

export default {
  weeklyEmployeeNewJobs: {
    title: 'Weekly Emails',
    description: 'On a weekly basis',
    // hide: ({ isReferralsFeatureEnabled }) => !isReferralsFeatureEnabled,
    tabs: [
      {
        title: 'Rich Content Email',
        key: 'rich-content-email',
      }
    ],
    fields: [
      // {
      //   key: 'preferences.sendWeeklyEmployeeNewJobsEmails',
      //   label: 'Send weekly summary emails to employees',
      //   description: 'Send employees a weekly summary email with new jobs & new matches on the platform',
      //   type: 'boolean',
      // },
      {
        key: 'template.EMAIL_EMPLOYEE_WEEKLY_JOBS_SUBJECT',
        label: 'Email Subject',
        type: 'template',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_WEEKLY_JOBS_BODY_ONE',
        label: 'Email Top Message',
        type: 'template',
        markdown: true,
        tab: 'rich-content-email',
      },
    ],
    sendTestEmail: buildTestEmail('weekly-emails/employee-jobs', {
      template_subject: 'template.EMAIL_EMPLOYEE_WEEKLY_JOBS_SUBJECT',
      template_bodyOne: 'template.EMAIL_EMPLOYEE_WEEKLY_JOBS_BODY_ONE',
    }),
    testDataQuery: getEmailQuery({
      company: `

      contentShares(where: { status: ACTIVE }, order: CREATED_DESC, limit: 3) {
        id
        title
        description
        image {
          fileLocation
        }
        url
      }

      preferences {
        isReferralsFeatureEnabled
        isContentShareToolEnabled
        isInternalMobilityEnabled
        isMentorshipFeatureEnabled
        canSyncContacts
        hideJobExcerpts
        useGamification
        departmentLabel
        jobReferralBonusDefault
      }

      template_subject: template(where: { key: "EMAIL_EMPLOYEE_WEEKLY_JOBS_SUBJECT", lang: "en", default: false }) {
        value
      }
      template_bodyOne: template(where: { key: "EMAIL_EMPLOYEE_WEEKLY_JOBS_BODY_ONE", lang: "en", default: false }) {
        value
      }`,
      user: `
        id
        firstName
        fullName
        title
        emailAddress

        jobs(where: { status: ACTIVE }, order: MOST_RELEVANT, limit: 15) {
          id
          title
          shareCode

          department {
            id
            name
          }
          location {
            id
            name
            countryCode
          }
          referralBonus
          customFieldsHash
        }
      `,
    }),
    mockData(result) {
      const { company } = result;

      // If no user was returned, insert fake details
      if (!result.user) {
        result.user = {
          id: 'EXAMPLE-USER-ID',
          firstName: 'John',
          fullName: 'John Appleseed',
          emailAddress: 'john.appleseed@reallinks.dev',
          title: 'Senior VP Engineering',
        };
      }

      // Fake referrals results
      if (company && company.preferences && company.preferences.isReferralsFeatureEnabled) {
        // If no jobs were returned, insert fake ones
        if (!(Array.isArray(result.user.jobs) && result.user.jobs.length)) {
          result.user.jobs = [
            { id: 'EXAMPLE-JOB-ID-1', title: 'Software Engineer' },
            { id: 'EXAMPLE-JOB-ID-2', title: 'Senior Marketing Lead' },
            { id: 'EXAMPLE-JOB-ID-3', title: 'Financial Assistant' },
          ];
        }

        // Set fake match counts for the first 5 jobs
        result.user.jobs = result.user.jobs.map((job, i) => ({
          ...job,
          matches: {
            total: (() => {
              switch (i) {
                case 0: return 21;
                case 1: return 15;
                case 2: return 9;
                case 3: return 3;
                case 4: return 1;
                default: return 0;
              }
            })(),
          },
        }));

        // If no leaderboard exists yet, insert a fake one
        if (!result.user.leaderboard) {
          result.user.leaderboard = {
            id: 'EXAMPLE-LEADERBOARD',
            name: 'Leaderboard',
            raffleMode: false,
            total: 100,
          };
        }

        // Fake the leaderboard score
        result.user.leaderboard.userScore = { total: 42 };
      } else {
        result.user.leaderboard = null;
        result.user.jobs = [];
      }

      // Fake internal mobility results
      if (company && company.preferences && company.preferences.isInternalMobilityEnabled) {
        result.company.jobs = JSON.parse(`[
          {
            "id": "Xrqbk",
            "title": "Marketing Executive - CRM",
            "department": null,
            "location": null,
            "customFieldsHash": {
              "location": "Paddington Station",
              "seniority": "Mid-level",
              "businessArea": "Sales & Marketing"
            },
            "imMatchingDetails": {
              "interestData": [
                {
                  "value": "Sales & Marketing",
                  "type": "JOB_BUSINESS_AREA"
                }
              ],
              "skillsData": [
                { "value": "Contact Management Systems" },
                { "value": "E-Marketing" },
                { "value": "CRM" }
              ]
            }
          },
          {
            "id": "RxGwp",
            "title": "Facility Development Project Manager",
            "location": null,
            "customFieldsHash": {
              "location": "London - The Point",
              "seniority": "Mid-level",
              "businessArea": "Commercial Development"
            },
            "imMatchingDetails": {
              "interestData": [
                {
                  "value": "Commercial Development",
                  "type": "JOB_BUSINESS_AREA"
                }
              ],
              "skillsData": null
            }
          }
        ]`);
        result.company.projectJobs = JSON.parse(`[
          {
            "id": "R92MD",
            "title": "Junior iOS Engineer",
            "isDevelopment": true,
            "location": null,
            "customFieldsHash": {
              "location": "London – Capital House",
              "seniority": "Mid-level",
              "businessArea": "Engineering"
            },
            "imMatchingDetails": {
              "interestData": [
                {
                  "value": "Engineering",
                  "type": "JOB_BUSINESS_AREA"
                }
              ],
              "skillsData": [
                { "value": "Apple IOS" },
                { "value": "Swift 3D" },
                { "value": "Swift" }
              ]
            },
            "project": {
              "id": "1K51K",
              "title": "Software and System Maintenance "
            }
          },
          {
            "id": "P5n09",
            "title": "Night Electrician",
            "isDevelopment": false,
            "location": null,
            "customFieldsHash": {
              "location": "Fratton Station",
              "seniority": "Mid-level",
              "businessArea": "Engineering"
            },
            "imMatchingDetails": {
              "interestData": [
                { "value": "Engineering" }
              ],
              "skillsData": null
            },
            "project": {
              "id": "1K51K",
              "title": "Software and System Maintenance "
            }
          }
        ]`);
        result.company.mentors = JSON.parse(`[
          {
            "id": "85p3Q",
            "fullName": "Adam Mittwoch",
            "imMatchingDetails": {
              "interestData": [
                {
                  "value": "Engineering",
                  "type": "JOB_BUSINESS_AREA"
                }
              ],
              "skillsData": [
                { "value": "Vue.js" },
                { "value": "Node.js" }
              ]
            }
          },
          {
            "id": "8nJM8",
            "fullName": "Otis Milburn",
            "imMatchingDetails": {
              "interestData": [
                {
                  "value": "Commercial Development",
                  "type": "JOB_BUSINESS_AREA"
                }
              ],
              "skillsData": null
            }
          }
        ]`);
      }

      return result;
    }
  },
  // employeeNewReferralRequest: {
  //   title: 'New Referral Request to Employee',
  //   description: 'Configure the weekly emails detailing new jobs to users',
  //   fields: [
  //     {
  //       key: 'preferences.sendReferralRequestEmployeeEmail',
  //       label: 'Send weekly summary emails to employees',
  //       description: 'Send employees a weekly summary email with new jobs & new matches on the platform',
  //       type: 'boolean',
  //     },
  //     {
  //       key: 'template.EMAIL_RECRUITER_ASK_EMPLOYEE_FOR_REFERRAL_SUBJECT',
  //       label: 'Email Subject',
  //       type: 'template',
  //     },
  //     {
  //       key: 'template.EMAIL_RECRUITER_ASK_EMPLOYEE_FOR_REFERRAL_BODY',
  //       label: 'Email Message',
  //       type: 'template',
  //     },
  //   ],
  // },
  /* howItWorks: {
    title: 'Reengagement » How It Works',
    description: 'Configure the "How it works" email sent to users, this email is sent to all new users 1 day after they have signed up.',
    tabs: [
      {
        title: 'Rich Content Email',
        key: 'rich-content-email',
      },
      {
        title: 'Plain Text Email',
        key: 'plain-text-email',
      }
    ],
    fields: [
      {
        key: 'preferences.employeeReengageHowItWorksEmailPlain',
        label: 'Use plain text email',
        description: 'Send plain text email as defined under the plain text email tab',
        type: 'boolean',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_REENGAGE_HOWITWORKS_SUBJECT',
        label: 'Email subject',
        type: 'template',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_REENGAGE_HOWITWORKS_PLAIN_HTML',
        label: 'Plain Text Email',
        type: 'template',
        markdown: true,
        tab: 'plain-text-email',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_REENGAGE_HOWITWORKS_BODY_ONE',
        label: 'Email top message',
        type: 'template',
        markdown: true,
        tab: 'rich-content-email',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_REENGAGE_HOWITWORKS_BODY_TWO',
        label: 'Email bottom message',
        type: 'template',
        markdown: true,
        tab: 'rich-content-email',
      },
    ],
    sendTestEmail: buildTestEmail('reengagement/how-it-works', {
      template_subject: 'template.EMAIL_EMPLOYEE_REENGAGE_HOWITWORKS_SUBJECT',
      template_bodyOne: 'template.EMAIL_EMPLOYEE_REENGAGE_HOWITWORKS_BODY_ONE',
      template_bodyTwo: 'template.EMAIL_EMPLOYEE_REENGAGE_HOWITWORKS_BODY_TWO',
      template_plainHTML: 'template.EMAIL_EMPLOYEE_REENGAGE_HOWITWORKS_PLAIN_HTML',
    }),
  }, */
  /* makeFirstReferral: {
    title: 'Reengagement » Make Your First Referral',
    description: 'Configure the "Make Your First Referral" email sent to users after they have sycned their connections.',
    tabs: [
      {
        title: 'Rich Content Email',
        key: 'rich-content-email',
      },
      {
        title: 'Plain Text Email',
        key: 'plain-text-email',
      }
    ],
    fields: [
      {
        key: 'preferences.makeFirstReferralEmailPlain',
        label: 'Use plain text email',
        description: 'Send plain text email as defined under the plain text email tab',
        type: 'boolean',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_REENGAGE_MAKEFIRSTREFERRAL_SUBJECT',
        label: 'Email subject',
        type: 'template',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_REENGAGE_MAKEFIRSTREFERRAL_PLAIN_HTML',
        label: 'Plain Text Email',
        type: 'template',
        markdown: true,
        tab: 'plain-text-email',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_REENGAGE_MAKEFIRSTREFERRAL_BODY_ONE',
        label: 'Email top message',
        type: 'template',
        markdown: true,
        tab: 'rich-content-email',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_REENGAGE_MAKEFIRSTREFERRAL_BODY_TWO',
        label: 'Email bottom message',
        type: 'template',
        markdown: true,
        tab: 'rich-content-email',
      },
    ],
    sendTestEmail: buildTestEmail('reengagement/make-first-referral', {
      template_subject: 'template.EMAIL_EMPLOYEE_REENGAGE_MAKEFIRSTREFERRAL_SUBJECT',
      template_bodyOne: 'template.EMAIL_EMPLOYEE_REENGAGE_MAKEFIRSTREFERRAL_BODY_ONE',
      template_bodyTwo: 'template.EMAIL_EMPLOYEE_REENGAGE_MAKEFIRSTREFERRAL_BODY_TWO',
      template_plainHTML: 'template.EMAIL_EMPLOYEE_REENGAGE_MAKEFIRSTREFERRAL_PLAIN_HTML',
    }),
  }, */
  reengageRewardsAreWaiting: {
    title: 'Reengagement » Rewards Are Waiting',
    description: '1 day after sign up to all users if gamification is enabled',
    hide: ({ isReferralsFeatureEnabled }) => !isReferralsFeatureEnabled,
    tabs: [
      {
        title: 'Rich Content Email',
        key: 'rich-content-email',
      },
      {
        title: 'Plain Text Email',
        key: 'plain-text-email',
      }
    ],
    fields: [
      {
        key: 'preferences.employeeReengageYourRewardsAreWaitingEmailPlain',
        label: 'Use plain text email',
        description: 'Send plain text email as defined under the plain text email tab',
        type: 'boolean',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_REENGAGE_REWARDS_ARE_WAITING_SUBJECT',
        label: 'Email subject',
        type: 'template',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_REENGAGE_REWARDS_ARE_WAITING_PLAIN_HTML',
        label: 'Plain Text Email',
        type: 'template',
        markdown: true,
        tab: 'plain-text-email',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_REENGAGE_REWARDS_ARE_WAITING_BODY_ONE',
        label: 'Email top message',
        type: 'template',
        markdown: true,
        tab: 'rich-content-email',
      },
    ],
    sendTestEmail: buildTestEmail('reengagement/your-rewards-are-waiting', {
      template_subject: 'template.EMAIL_EMPLOYEE_REENGAGE_REWARDS_ARE_WAITING_SUBJECT',
      template_bodyOne: 'template.EMAIL_EMPLOYEE_REENGAGE_REWARDS_ARE_WAITING_BODY_ONE',
      template_plainHTML: 'template.EMAIL_EMPLOYEE_REENGAGE_REWARDS_ARE_WAITING_PLAIN_HTML',
    }),
    testDataQuery: getEmailQuery({
      company: `preferences {
        useGamification
        employeeReengageYourRewardsAreWaitingEmailPlain
      }

      template_subject: template(where: {
        key: "EMAIL_EMPLOYEE_REENGAGE_REWARDS_ARE_WAITING_SUBJECT",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_bodyOne: template(where: {
        key: "EMAIL_EMPLOYEE_REENGAGE_REWARDS_ARE_WAITING_BODY_ONE",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_plainHTML: template(where: {
        key: "EMAIL_EMPLOYEE_REENGAGE_REWARDS_ARE_WAITING_PLAIN_HTML",
        lang: "en",
        default: false,
      }) {
        value
      }`,
      user: `leaderboard {
        raffleMode
        prizes {
          first {
            title
            image {
              id
              fileLocation
            }
          }
          second {
            title
            image {
              id
              fileLocation
            }
          }
          third {
            title
            image {
              id
              fileLocation
            }
          }
        }
      }`,
    }),
  },
  keepIntroducing: {
    title: 'Reengagement » Have you made your first introduction?',
    description: '10 days after sign up',
    hide: ({ isReferralsFeatureEnabled }) => !isReferralsFeatureEnabled,
    tabs: [
      {
        title: 'Rich Content Email',
        key: 'rich-content-email',
      },
      {
        title: 'Plain Text Email',
        key: 'plain-text-email',
      }
    ],
    fields: [
      {
        key: 'preferences.employeeReengageKeepIntroducingEmailPlain',
        label: 'Use plain text email',
        description: 'Send plain text email as defined under the plain text email tab',
        type: 'boolean',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_KEEP_INTRODUCING_SUBJECT',
        label: 'Email subject',
        type: 'template',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_KEEP_INTRODUCING_PLAIN_HTML',
        label: 'Plain Text Email',
        type: 'template',
        markdown: true,
        tab: 'plain-text-email',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_KEEP_INTRODUCING_BODY_ONE',
        label: 'Email top message',
        type: 'template',
        markdown: true,
        tab: 'rich-content-email',
      },
    ],
    sendTestEmail: buildTestEmail('reengagement/keep-introducing', {
      template_subject: 'template.EMAIL_EMPLOYEE_KEEP_INTRODUCING_SUBJECT',
      template_bodyOne: 'template.EMAIL_EMPLOYEE_KEEP_INTRODUCING_BODY_ONE',
      template_plainHTML: 'template.EMAIL_EMPLOYEE_KEEP_INTRODUCING_PLAIN_HTML',
    }),
    testDataQuery: getEmailQuery({
      company: `preferences {
        useGamification
        employeeReengageKeepIntroducingEmailPlain
      }

      template_subject: template(where: {
        key: "EMAIL_EMPLOYEE_KEEP_INTRODUCING_SUBJECT",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_bodyOne: template(where: {
        key: "EMAIL_EMPLOYEE_KEEP_INTRODUCING_BODY_ONE",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_plainHTML: template(where: {
        key: "EMAIL_EMPLOYEE_KEEP_INTRODUCING_PLAIN_HTML",
        lang: "en",
        default: false,
      }) {
        value
      }`,
    }),
  },
  noReferralsNoWorries: {
    title: 'Reengagement » No Introductions No Worries',
    description: '15 days after sign up (If content sharing is enabled)',
    hide: ({ isReferralsFeatureEnabled }) => !isReferralsFeatureEnabled,
    tabs: [
      {
        title: 'Rich Content Email',
        key: 'rich-content-email',
      },
      {
        title: 'Plain Text Email',
        key: 'plain-text-email',
      }
    ],
    fields: [
      {
        key: 'preferences.employeeReengageNoReferralsNoWorriesEmailPlain',
        label: 'Use plain text email',
        description: 'Send plain text email as defined under the plain text email tab',
        type: 'boolean',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_NO_REFERRALS_NO_WORRIES_EMAIL_SUBJECT',
        label: 'Email subject',
        type: 'template',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_NO_REFERRALS_NO_WORRIES_EMAIL_PLAIN_HTML',
        label: 'Plain Text Email',
        type: 'template',
        markdown: true,
        tab: 'plain-text-email',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_NO_REFERRALS_NO_WORRIES_EMAIL_BODY_ONE',
        label: 'Email top message',
        type: 'template',
        markdown: true,
        tab: 'rich-content-email',
      },
    ],
    sendTestEmail: buildTestEmail('reengagement/no-referrals-no-worries', {
      template_subject: 'template.EMAIL_EMPLOYEE_NO_REFERRALS_NO_WORRIES_EMAIL_SUBJECT',
      template_bodyOne: 'template.EMAIL_EMPLOYEE_NO_REFERRALS_NO_WORRIES_EMAIL_BODY_ONE',
      template_plainHTML: 'template.EMAIL_EMPLOYEE_NO_REFERRALS_NO_WORRIES_EMAIL_PLAIN_HTML',
    }),
    testDataQuery: getEmailQuery({
      company: `preferences {
        useGamification
        employeeReengageYourRewardsAreWaitingEmailPlain
      }

      template_subject: template(where: {
        key: "EMAIL_EMPLOYEE_NO_REFERRALS_NO_WORRIES_EMAIL_SUBJECT",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_bodyOne: template(where: {
        key: "EMAIL_EMPLOYEE_NO_REFERRALS_NO_WORRIES_BODY_ONE",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_plainHTML: template(where: {
        key: "EMAIL_EMPLOYEE_NO_REFERRALS_NO_WORRIES_EMAIL_PLAIN_HTML",
        lang: "en",
        default: false,
      }) {
        value
      }`,
    }),
  },
  newContentToShare: {
    title: 'Reengagement » New Content to Share',
    description: '20 days after sign up (If content sharing is enabled)',
    tabs: [
      {
        title: 'Rich Content Email',
        key: 'rich-content-email',
      },
      {
        title: 'Plain Text Email',
        key: 'plain-text-email',
      }
    ],
    fields: [
      {
        key: 'preferences.employeeReengageNewContentToShareEmailPlain',
        label: 'Use plain text email',
        description: 'Send plain text email as defined under the plain text email tab',
        type: 'boolean',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_NEW_CONTENT_TO_SHARE_EMAIL_SUBJECT',
        label: 'Email subject',
        type: 'template',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_NEW_CONTENT_TO_SHARE_EMAIL_PLAIN_HTML',
        label: 'Plain Text Email',
        type: 'template',
        markdown: true,
        tab: 'plain-text-email',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_NEW_CONTENT_TO_SHARE_EMAIL_BODY_ONE',
        label: 'Email top message',
        type: 'template',
        markdown: true,
        tab: 'rich-content-email',
      },
    ],
    sendTestEmail: buildTestEmail('reengagement/new-content-to-share', {
      template_subject: 'template.EMAIL_EMPLOYEE_NEW_CONTENT_TO_SHARE_EMAIL_SUBJECT',
      template_bodyOne: 'template.EMAIL_EMPLOYEE_NEW_CONTENT_TO_SHARE_EMAIL_BODY_ONE',
      template_plainHTML: 'template.EMAIL_EMPLOYEE_NEW_CONTENT_TO_SHARE_EMAIL_PLAIN_HTML',
    }),
    testDataQuery: getEmailQuery({
      company: `preferences {
        useGamification
        employeeReengageNewContentToShareEmailPlain
      }

      contentShareConnections(
        where: { status: ACTIVE },
        limit: 1,
        order: CREATED_DESC
      ) {
        edges {
          entry {
            id
            title
            description
            image {
              id
              fileLocation
            }
          }
        }
      }

      template_subject: template(where: {
        key: "EMAIL_EMPLOYEE_NEW_CONTENT_TO_SHARE_EMAIL_SUBJECT",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_bodyOne: template(where: {
        key: "EMAIL_EMPLOYEE_NEW_CONTENT_TO_SHARE_EMAIL_BODY_ONE",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_plainHTML: template(where: {
        key: "EMAIL_EMPLOYEE_NEW_CONTENT_TO_SHARE_EMAIL_PLAIN_HTML",
        lang: "en",
        default: false,
      }) {
        value
      }`,
    }),
  },
  youArePlatformPro: {
    title: 'Reengagement » You Are a Platform Pro',
    description: '1 day after sharing a job or a pice of company content',
    hide: ({ isReferralsFeatureEnabled }) => !isReferralsFeatureEnabled,
    tabs: [
      {
        title: 'Rich Content Email',
        key: 'rich-content-email',
      },
      {
        title: 'Plain Text Email',
        key: 'plain-text-email',
      }
    ],
    fields: [
      {
        key: 'preferences.employeeReengageYouAreProEmailPlain',
        label: 'Use plain text email',
        description: 'Send plain text email as defined under the plain text email tab',
        type: 'boolean',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_PLATFORM_PRO_SUBJECT',
        label: 'Email subject',
        type: 'template',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_PLATFORM_PRO_PLAIN_HTML',
        label: 'Plain Text Email',
        type: 'template',
        markdown: true,
        tab: 'plain-text-email',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_PLATFORM_PRO_BODY_ONE',
        label: 'Email top message',
        type: 'template',
        markdown: true,
        tab: 'rich-content-email',
      },
    ],
    sendTestEmail: buildTestEmail('reengagement/platform-pro', {
      template_subject: 'template.EMAIL_EMPLOYEE_PLATFORM_PRO_SUBJECT',
      template_bodyOne: 'template.EMAIL_EMPLOYEE_PLATFORM_PRO_BODY_ONE',
      template_plainHTML: 'template.EMAIL_EMPLOYEE_PLATFORM_PRO_PLAIN_HTML',
    }),
    testDataQuery: getEmailQuery({
      company: `preferences {
        useGamification
        employeeReengageYouAreProEmailPlain
      }

      template_subject: template(where: {
        key: "EMAIL_EMPLOYEE_PLATFORM_PRO_SUBJECT",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_bodyOne: template(where: {
        key: "EMAIL_EMPLOYEE_PLATFORM_PRO_BODY_ONE",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_plainHTML: template(where: {
        key: "EMAIL_EMPLOYEE_PLATFORM_PRO_PLAIN_HTML",
        lang: "en",
        default: false,
      }) {
        value
      }`,
    }),
  },
  latestMatches: {
    title: 'Reengagement » Your Latest Matches',
    description: '1 day after syncing connections to users with strong matches in same location as role',
    hide: ({ isReferralsFeatureEnabled }) => !isReferralsFeatureEnabled,
    tabs: [
      {
        title: 'Rich Content Email',
        key: 'rich-content-email',
      },
      {
        title: 'Plain Text Email',
        key: 'plain-text-email',
      }
    ],
    fields: [
      {
        key: 'preferences.employeeReengageLatestMatchesEmailPlain',
        label: 'Use plain text email',
        description: 'Send plain text email as defined under the plain text email tab',
        type: 'boolean',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_LATEST_MATCHES_SUBJECT',
        label: 'Email subject',
        type: 'template',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_LATEST_MATCHES_PLAIN_HTML',
        label: 'Plain Text Email',
        type: 'template',
        markdown: true,
        tab: 'plain-text-email',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_LATEST_MATCHES_BODY_ONE',
        label: 'Email top message',
        type: 'template',
        markdown: true,
        tab: 'rich-content-email',
      },
    ],
    sendTestEmail: buildTestEmail('reengagement/latest-matches', {
      template_subject: 'template.EMAIL_EMPLOYEE_LATEST_MATCHES_SUBJECT',
      template_bodyOne: 'template.EMAIL_EMPLOYEE_LATEST_MATCHES_BODY_ONE',
      template_plainHTML: 'template.EMAIL_EMPLOYEE_LATEST_PLAIN_HTML',
    }),
    testDataQuery: getEmailQuery({
      company: `preferences {
        canSyncContacts
        employeeReengageLatestMatchesEmailPlain
      }

      template_subject: template(where: {
        key: "EMAIL_EMPLOYEE_LATEST_MATCHES_SUBJECT",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_bodyOne: template(where: {
        key: "EMAIL_EMPLOYEE_LATEST_MATCHES_BODY_ONE",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_plainHTML: template(where: {
        key: "EMAIL_EMPLOYEE_LATEST_MATCHES_PLAIN_HTML",
        lang: "en",
        default: false,
      }) {
        value
      }`,
    }),
    mockData(result) {
      const fakeData = {
        user: {
          matchedJobs: [
            {
              id: 'Xjlam',
              title: 'Marketing Executive',
              shareCode: 'mk3IVg',
              location: {
                id: '2643743',
                name: 'London',
              },
              excerpt: 'We need an enthusiastic graduate to join our marketing team and take ownership of our campaign strategy. You are going to be an ambitious and creative multi-tasker who will relish the opportunity to put great ideas into practice. Your main responsibility is to drive understanding, awareness and demand for the GapCap products, building trust in the brand and spreading the word to the UK’s SME community. You will be interacting with different departments in the business every day.',
              matches: {
                total: 22,
                edges: [
                  {
                    entry: {
                      fullName: 'Cristian Mertz',
                      avatar: '13',
                      latestEmployment: {
                        companyName: 'nevro',
                      },
                    },
                  },
                  {
                    entry: {
                      fullName: 'Yvonne Leuschke',
                      avatar: '2',
                      latestEmployment: {
                        companyName: 'centaur media plc',
                      },
                    },
                  },
                  {
                    entry: {
                      fullName: 'Lexi Zulauf',
                      avatar: '12',
                      latestEmployment: {
                        companyName: 'alzheimer\'s society',
                      },
                    },
                  },
                  {
                    entry: {
                      fullName: 'Cydney Bauch',
                      avatar: '7',
                      latestEmployment: {
                        companyName: 'springer',
                      },
                    },
                  },
                  {
                    entry: {
                      fullName: 'Jalen Jacobi',
                      avatar: '2',
                      latestEmployment: {
                        companyName: 'becrypt',
                      },
                    },
                  },
                ],
              },
            },
            {
              id: 'R1dam',
              title: 'Digital Marketing & Comms Executive2',
              shareCode: '0y2HJm',
              location: {
                id: '2643743',
                name: 'London',
              },
              excerpt: 'The Marketing and Communications Executive will build awareness for and support the promotion of Di product offerings by generating engaging marketing and communication content. This is to help with the internal development of a digital platform to host a suite a digital products used by the client’s customers and their contacts. —-',
              matches: {
                total: 9,
                edges: [
                  {
                    entry: {
                      fullName: 'Yvonne Leuschke',
                      avatar: '2',
                      latestEmployment: {
                        companyName: 'centaur media plc',
                      },
                    },
                  },
                  {
                    entry: {
                      fullName: 'Lexi Zulauf',
                      avatar: '12',
                      latestEmployment: {
                        companyName: 'alzheimer\'s society',
                      },
                    },
                  },
                  {
                    entry: {
                      fullName: 'Jalen Jacobi',
                      avatar: '2',
                      latestEmployment: {
                        companyName: 'becrypt',
                      },
                    },
                  },
                  {
                    entry: {
                      fullName: 'Cydney Bauch',
                      avatar: '7',
                      latestEmployment: {
                        companyName: 'springer',
                      },
                    },
                  },
                  {
                    entry: {
                      fullName: 'Al Turner',
                      avatar: '14',
                      latestEmployment: {
                        companyName: 'miller insurance services',
                      },
                    },
                  },
                ],
              },
            },
          ],
        },
      };
      return {
        ...result,
        user: {
          ...result.user,
          ...fakeData.user,
        },
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/emails/previews/reengagementEmails.js